import helpers from './helpers'

export default {

  // Transmit to viewer
  reset () { this.postMessageToViewer('resetView') },
  dimensions () { this.postMessageToViewer('showDimensions') },
  screenshot () { this.postMessageToViewer('getCurrentDataURL') },
  screenshotCentered () { this.postMessageToViewer('getDataURL') },
  launchStaticicAR () { this.postMessageToViewer('launchStaticAR') },
  launchDynamicAR () { this.postMessageToViewer('launchAR') },
  loadOption (element) { this.postMessageToViewer('selectConfiguration', { parameters: JSON.stringify(element) }) },
  getName () { this.postMessageToViewer('getName') },
  getPrice () { this.postMessageToViewer('getPrice') },
  getSummary () { this.postMessageToViewer('getConfigurationSummary') },
  getConfiguration () { this.postMessageToViewer('getConfigurationCode') },

  postMessageToViewer (type, data) {
    const message = { type: type }
    for (var key in data) message[key] = data[key]
    helpers.getViewer().contentWindow.postMessage(message, '*')
  },

  // Transmit to parent
  postName (name) { this.postMessageToParent('name', { name: name }) },
  postPrice (price) { this.postMessageToParent('price', { price: price }) },
  postSummary (summary) { this.postMessageToParent('summary', { summary: summary }) },
  postConfiguration (configuration) { this.postMessageToParent('configuration', { configuration: configuration }) },

  postMessageToParent (type, data) {
    const message = { type: type }
    for (var key in data) message[key] = data[key]
    window.parent.postMessage(message, '*')
  },
}
